<template>
  <div class="l-the-side-menu">
    <div class="p-the-side-menu">
      <slot />
      <div v-if="isShowCat" class="p-the-side-menu__links">
        <!--
        <a href="/ranking" class="p-the-side-menu__ranking">
          <IconBase
            view-box="0 0 32 32"
            width="32"
            height="32"
            icon-color="transparent"
          >
            <IconRanking :icon-color="colorCode" />
          </IconBase>
          <span class="p-the-side-menu__ranking__label">ランキング</span>
        </a>
-->
        <p class="p-the-side-menu__label">商品カテゴリー</p>
        <TheCategoryList
          :categories="categories"
          :link="link"
          class="p-the-side-menu__category-list"
          @click-subcategory="clickOnSubcategory($event)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TheCategoryList from "@/general/components/organisms/sideMenu/TheCategoryList.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconRanking from "@/common/components/icons/IconRanking.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Options({
  props: {
    categories: { type: Array, required: true },
    link: { type: Boolean, required: false, default: false },
    isShowCat: { type: Boolean, required: false, default: true }
  },
  components: {
    TheCategoryList,
    IconBase,
    IconRanking
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheSideMenu extends Vue {
  categories!: any;
  link!: boolean;
  isShowCat!: boolean;

  clickOnSubcategory(id: number) {
    this.$emit("click-subcategory", id);
  }
}
</script>

<style lang="scss" scoped>
.p-the-side-menu {
  height: 100%;

  @include large-pc {
    padding: rem(56) rem(32) rem(56) 0;
    width: rem(368);
    border-right: 1px solid $common-gray-border;
  }

  &__links {
    @include large-sp {
      display: none;
    }
  }

  &__ranking {
    margin-top: rem(80);
    padding: rem(8) 0;
    border-bottom: px(1) solid #dadada;
    width: 100%;
    display: flex;
    align-items: center;

    &__label {
      font-weight: bold;
      margin-left: rem(16);
    }
  }

  &__label {
    font-weight: bold;
    color: $common-gray500;
    margin-top: rem(24);
  }

  &__category-list {
    margin-top: rem(24);
  }
}
</style>
